/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from 'react';
import './style.css'
import ProjectInfo from './ProjectInfo';
import Action from './Action';
import Disclaimer from './Disclaimer';
import TabBottom from './TabBottom';
import { apiLaunchPad } from '../../../api/apiLaunchPad';
import { useLocation, useNavigate } from 'react-router-dom';
import { useSwitchChain, useAccount } from "wagmi";
import { message, Spin } from 'antd';
import { LoadingOutlined } from '@ant-design/icons';

const convertToTimestamp = (isoString: any) => isoString ? new Date(isoString).getTime() : null;
const COMMING = 1
const OPEN = 2
const END = 3

const DetailsIdo = () => {
    const { address }: any = useAccount();
    const location = useLocation();
    const { switchChainAsync } = useSwitchChain()
    const navigate = useNavigate();
    const [dataDetail, setDataDetail]: any = useState()
    const [tab, setTab] = useState(0)
    const [dataFromChild, setDataFromChild]: any = useState(false);
    const [dataFromChild1, setDataFromChild1]: any = useState(false);
    const [currentChainId, setCurrentChainId] = useState<string | null>(null);
    const [showNetworkWarning, setShowNetworkWarning] = useState(false);
    const [loading, setLoading] = useState(false);

    const handleDataFromChild = (data: any) => {
        setDataFromChild(data);
    };
    const handleDataFromChild1 = (data: any) => {
        setDataFromChild1(data);
    };

    function handleClickTab(arg0: number) {
        setTab(arg0)
    }

    let slug = location.pathname.split('/').pop();

    useEffect(() => {
        if (!slug) {
            navigate('/launchpads');
        }
    }, [slug]);

    const GetDataDetail = async () => {
        try {
            let res = await apiLaunchPad.getDetailLaunchpad(slug);
            if (res.data.code === 200) {
                setDataDetail(res?.data?.data)
            } else {
                setDataDetail(null)
            }
        } catch (error) {
            setDataDetail(null)
            console.log("Error: ", error);
        }
    };

    useEffect(() => {
        GetDataDetail()
    }, [slug, dataFromChild, dataFromChild]);

    let curentTime = Date.now()
    let startTimeMs = new Date(dataDetail?.start_time).getTime();
    let endTimeMs = new Date(dataDetail?.end_time).getTime();

    const [statusProject, setStatusProject]: any = useState()
    const getStatusProject = () => {
        if (startTimeMs > curentTime) {
            setStatusProject(COMMING)
        } else if (curentTime >= startTimeMs && curentTime <= endTimeMs) {
            setStatusProject(OPEN)
        } else if (curentTime > endTimeMs) {
            setStatusProject(END)
        }
    }
    useEffect(() => {
        getStatusProject()
    }, [dataDetail])


    const checkNetwork = async () => {
        if (statusProject === OPEN) {
            if (window.ethereum && dataDetail?.currency?.chain?.chain_id) {
                try {
                    const chainId = await window.ethereum.request({ method: 'eth_chainId' });
                    setCurrentChainId(chainId);
                    const expectedChainId = `0x${parseInt(dataDetail.currency.chain.chain_id).toString(16)}`;
                    setShowNetworkWarning(chainId !== expectedChainId);
                } catch (err: any) {
                    message.error({
                        type: "error",
                        content: err,
                        className: "custom-class",
                        duration: 2,
                    });
                    console.log('err', err)
                }
            }
        } else if (statusProject === END) {
            if (window.ethereum && dataDetail?.token?.chain?.chain_id) {
                try {
                    const chainId = await window.ethereum.request({ method: 'eth_chainId' });
                    setCurrentChainId(chainId);
                    const expectedChainId = `0x${parseInt(dataDetail.token.chain.chain_id).toString(16)}`;
                    setShowNetworkWarning(chainId !== expectedChainId);
                } catch (err: any) {
                    message.error({
                        type: "error",
                        content: err,
                        className: "custom-class",
                        duration: 2,
                    });
                    console.log('err', err)
                }
            }
        } else {
            setShowNetworkWarning(false)
        }
    };



    const handleSwitchChain = async () => {
        if (statusProject === OPEN) {
            try {
                if (!address) return;
                setLoading(true)
                await switchChainAsync({
                    chainId: dataDetail?.currency?.chain?.chain_id,
                });

                const chainId = await window.ethereum.request({ method: 'eth_chainId' });
                setTimeout(async () => {
                    if (Number(chainId) === dataDetail?.currency?.chain?.chain_id) {
                        setLoading(false)
                        message.success({
                            type: "success",
                            content: 'Switched Chain Successfully',
                            className: "custom-class",
                            duration: 2,
                        });
                    } else {
                        setLoading(false)
                        message.error({
                            type: "error",
                            content: 'Switched chain but not updated yet. Please try again.',
                            className: "custom-class",
                            duration: 2,
                        });
                    }
                }, 1000);
            } catch (err: any) {
                const chainId = await window.ethereum.request({ method: 'eth_chainId' });
                setTimeout(async () => {
                    if (Number(chainId) === dataDetail?.currency?.chain?.chain_id) {
                        setLoading(false)
                        message.success({
                            type: "success",
                            content: 'Switched Chain Successfully',
                            className: "custom-class",
                            duration: 2,
                        });
                    } else {
                        setLoading(false)
                        const isUserRejected =
                            err?.code === 4001 || err?.name === "UserRejectedRequestError";
                        message.error({
                            type: "error",
                            content: isUserRejected
                                ? "User rejected the request"
                                : err?.message || "Failed to switch chain",
                            className: "custom-class",
                            duration: 2,
                        });
                    }
                }, 1000);
            }
        } else if (statusProject === END) {
            try {
                if (!address) return;
                setLoading(true)
                await switchChainAsync({
                    chainId: dataDetail?.token?.chain?.chain_id,
                });

                const chainId = await window.ethereum.request({ method: 'eth_chainId' });
                setTimeout(async () => {
                    if (Number(chainId) === dataDetail?.token?.chain?.chain_id) {
                        setLoading(false)
                        message.success({
                            type: "success",
                            content: 'Switched Chain Successfully',
                            className: "custom-class",
                            duration: 2,
                        });
                    } else {
                        setLoading(false)
                        message.error({
                            type: "error",
                            content: 'Switched chain but not updated yet. Please try again.',
                            className: "custom-class",
                            duration: 2,
                        });
                    }
                }, 1000);
            } catch (err: any) {
                const chainId = await window.ethereum.request({ method: 'eth_chainId' });
                setTimeout(async () => {
                    if (Number(chainId) === dataDetail?.token?.chain?.chain_id) {
                        setLoading(false)
                        message.success({
                            type: "success",
                            content: 'Switched Chain Successfully',
                            className: "custom-class",
                            duration: 2,
                        });
                    } else {
                        setLoading(false)
                        const isUserRejected =
                            err?.code === 4001 || err?.name === "UserRejectedRequestError";
                        message.error({
                            type: "error",
                            content: isUserRejected
                                ? "User rejected the request"
                                : err?.message || "Failed to switch chain",
                            className: "custom-class",
                            duration: 2,
                        });
                    }
                }, 1000);
            }
        }

    };


    useEffect(() => {
        const handleChainChanged = (chainId: string) => {
            setCurrentChainId(chainId);
        };

        if (window.ethereum) {
            window.ethereum.on('chainChanged', handleChainChanged);
        }

        return () => {
            if (window.ethereum) {
                window.ethereum.removeListener('chainChanged', handleChainChanged);
            }
        };
    }, []);

    useEffect(() => {
        if (dataDetail) {
            checkNetwork();
        }
    }, [dataDetail, statusProject, currentChainId]);

    function goToLink(link: any): void {
        window.open(link)
    }

    function goToLaunchPad(): void {
        navigate('/launchpads');
    }

    useEffect(() => {
        window.scrollTo({
            top: 0,
            behavior: 'smooth'
        });
    }, []);

    const [isScrolled, setIsScrolled] = useState(false);
    useEffect(() => {
        const handleScroll = () => {
            setIsScrolled(window.scrollY > 50);
        };

        window.addEventListener('scroll', handleScroll);
        return () => window.removeEventListener('scroll', handleScroll);
    }, []);
    return (
        <>
            <div className="main-page-launchpad">
                <div className="container-fluid detail-ido">
                    {showNetworkWarning && address ? (
                        <>
                            <div className={`network-warning ${isScrolled ? 'shrink' : ''}`}>
                                <div className="content-warning">
                                    <img src="/images/red-warning.svg" alt="Warning" />
                                    <div className="text-warning">
                                        {statusProject === OPEN ? (
                                            <>
                                                Please switch to {dataDetail?.currency?.chain?.name}.
                                            </>
                                        ) : (
                                            <>
                                                Please switch to {dataDetail?.token?.chain?.name}.
                                            </>
                                        )}

                                        {loading ? (
                                            <button className='btn-re dis'>
                                                Waiting
                                                <div className="btn-ab dis"></div>
                                            </button>
                                        ) : (
                                            <button className='btn-re' onClick={handleSwitchChain}>
                                                Switch Now
                                                <div className="btn-ab"></div>
                                            </button>
                                        )}

                                    </div>
                                </div>

                            </div>
                            <div className="line-arrow">
                                <div className="item-arrow" onClick={goToLaunchPad}>Launchpad</div>
                                <div className="img-arrow">{'>'}</div>
                                <div className="item-arrow active">{dataDetail?.title || ''}</div>
                            </div>
                        </>
                    ) : (
                        <div className="line-arrow-no">
                            <div className="item-arrow" onClick={goToLaunchPad}>Launchpad</div>
                            <div className="img-arrow">{'>'}</div>
                            <div className="item-arrow active">{dataDetail?.title || ''}</div>
                        </div>
                    )}


                    <div className="group1">
                        <div className="group1-left">
                            <img className='logo-project' src={dataDetail?.avatar} alt="" />
                            <div className="project-info">
                                <div className="project-name">{dataDetail?.title || ''}</div>
                                <div className="project-symbol">{dataDetail?.token?.symbol}</div>
                            </div>
                        </div>
                        <div className="group1-right">
                            <div className="ido-type">{dataDetail?.campaign_type}</div>
                            <div className="ido-social">
                                <div className="social-item" onClick={() => goToLink(dataDetail?.website_link)}>
                                    <img className='social-item-img' src="/images/detail-ido/social-web.png" alt="" />
                                </div>
                                <div className="social-item" onClick={() => goToLink(dataDetail?.telegram_link)}>
                                    <img className='social-item-img' src="/images/detail-ido/social-tele.png" alt="" />
                                </div>
                                <div className="social-item" onClick={() => goToLink(dataDetail?.x_link)}>
                                    <img className='social-item-img' src="/images/detail-ido/social-x.png" alt="" />
                                </div>
                                <div className="social-item" onClick={() => goToLink(dataDetail?.discord_link)}>
                                    <img className='social-item-img' src="/images/detail-ido/social-discor.png" alt="" />
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="group2">
                        <div className="list-tab">
                            <div
                                className={`tab-item ${tab === 0 ? 'active' : ''}`}
                                onClick={() => handleClickTab(0)}
                            >Project info</div>
                            <div
                                className={`tab-item ${tab === 1 ? 'active' : ''}`}
                                onClick={() => handleClickTab(1)}
                            >Participate & Claim</div>
                            <div
                                className={`tab-item ${tab === 2 ? 'active' : ''}`}
                                onClick={() => handleClickTab(2)}
                            >legal disclaimer</div>
                        </div>
                        <div className="line-tab"></div>
                    </div>

                    {tab === 0 && <ProjectInfo data={dataDetail} />}
                    {tab === 1 && <Action
                        launchpadDetail={dataDetail}
                        onSendData={handleDataFromChild}
                        onSendData1={handleDataFromChild1}
                        startTime={convertToTimestamp(dataDetail?.start_time)}
                        showNetworkWarning={showNetworkWarning}
                    />}
                    {tab === 2 && <Disclaimer />}
                    {tab === 0 && (
                        <div className="group-bottom">
                            <TabBottom
                                des={dataDetail?.description}
                                shortDes={dataDetail?.short_description}
                                tokenMetrics={dataDetail?.token_metrics}
                                roadmap={dataDetail?.roadmap}
                                partner={dataDetail?.partner_and_investor}
                                team={dataDetail?.team}
                            />
                        </div>
                    )}
                </div>
            </div>
        </>
    )
}

export default DetailsIdo;
